import { render } from "./Index.vue?vue&type=template&id=3c3f35ec"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Items/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c3f35ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c3f35ec', __exports__)) {
    console.log('reload')
    api.reload('3c3f35ec', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=3c3f35ec", () => {
    console.log('re-render')
    api.rerender('3c3f35ec', render)
  })

}


export default __exports__